<template>
  <v-snackbar
    v-model="snackbar.visible"
    :timeout="snackbar.timeout"
    :multi-line="snackbar.multiline === true"
    :color="snackbar.color"
    :class="(snackbar.ok) ? 'ok' : ''"
  >
    <template v-if="snackbar.ok">
      <v-icon>mdi-check</v-icon>
    </template>
    <template v-else >
    {{ $t(snackbar.text) }}
    <v-btn
      color="red"
      text
      @click="closeAlert"
    >
      <v-icon color="white">mdi-close</v-icon>
    </v-btn>
    </template>
  </v-snackbar>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  computed: {
    snackbar() {
      return this.$store.state.snackbar;
    }
  },
  methods: {
    ...mapMutations(["closeAlert"])
  }
};
</script>

<style>
.v-snack__wrapper.success {
  min-width: 58px !important;
  max-width: 50px !important;
  margin-right: 0;
}
</style>